import { MerchantLocation } from '@slerp/controls'
import { LeatStoreLink } from './types'

// Repo-wide "active" convention (e.g. Home/Stats.tsx, ProductsAndModifiers/
// Modifiers) — archived_at, not is_open, which only reflects today's hours.
export const getActiveStores = (
  merchantLocations: MerchantLocation[]
): MerchantLocation[] => merchantLocations.filter((store) => !store.archived_at)

export const formatStoreAddress = (
  address: MerchantLocation['address'] | undefined
): string => {
  if (!address?.line_1) return '—'
  const cityZip = [address.city, address.zip].filter(Boolean).join(' · ')
  return cityZip ? `${address.line_1}, ${cityZip}` : address.line_1
}

export const findStoreLink = (
  storeId: string,
  links: LeatStoreLink[]
): LeatStoreLink | undefined => links.find((link) => link.id === storeId)

export const isLeatConnected = (
  storeId: string,
  links: LeatStoreLink[]
): boolean =>
  Boolean(
    findStoreLink(storeId, links)?.store_integration_settings.leat_store_id
  )
